export { default } from './PayrixPaymentsStatusPanel';
